// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles((theme) => ({
	helpText: {
		fontSize: '14px',
		marginBottom: '6px',
	},
	supportBtn: {
		borderRadius: '4px',
		backgroundColor: '#bedc13',
		height: '48px',
		width: '250px',
		'&:hover': {
			backgroundColor: '#bedc13',
		},
		marginBottom: '10px',
	},
	icon: {
		// Default icon styles - can be overridden by parent if needed
	},
}));

const stars = [1, 2, 3, 4, 5];

type Props = {
	orders: Array<any>,
	onSupportClick: Function,
	onRatingClick: Function,
	logEvent: Function,
};

function OrderHelpSection({
	orders,
	onSupportClick,
	onRatingClick,
	logEvent,
}: Props) {
	const styles = useStyles();

	const handleSupportClick = () => {
		// For multiple orders, use the first order's ID for support
		const firstOrderId = orders.length > 0 ? orders[0].order_id : '';
		if (firstOrderId) {
			onSupportClick(firstOrderId);
			logEvent('view_customer_support');
		}
	};

	const handleRatingClick = () => {
		onRatingClick();
		logEvent('open_rating');
	};

	return (
		<section
			style={{
				margin: '40px 0 10px',
				width: '100%',
				textAlign: 'center',
				paddingBottom: '10px',
			}}
		>
			<div className={styles.helpText}>Need help with this order?</div>
			<Button
				variant='contained'
				aria-label='Support'
				classes={{ contained: styles.supportBtn }}
				onClick={handleSupportClick}
			>
				Contact Support
			</Button>
			<div
				onClick={handleRatingClick}
				style={{ marginBottom: 10, cursor: 'pointer' }}
			>
				{stars.map((key) => (
					<Icon className={styles.icon} key={key}>
						star_outline
					</Icon>
				))}
			</div>
		</section>
	);
}

export default OrderHelpSection;